// Bundled locally (no CDN request). Latin subsets for English UI; Indic
// scripts are separate Noto families (fontsource does not ship Kannada/Oriya
// inside @fontsource/noto-sans). See app.css .tym-locale-indic.
import '@fontsource/dm-sans/latin-400.css';
import '@fontsource/dm-sans/latin-500.css';
import '@fontsource/dm-sans/latin-700.css';
import '@fontsource/poppins/latin-300.css';
import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-500.css';
import '@fontsource/poppins/latin-600.css';
import '@fontsource/poppins/latin-700.css';
import '@fontsource/noto-sans/devanagari-400.css';
import '@fontsource/noto-sans/devanagari-500.css';
import '@fontsource/noto-sans/devanagari-700.css';
import '@fontsource/noto-sans-kannada/kannada-400.css';
import '@fontsource/noto-sans-kannada/kannada-500.css';
import '@fontsource/noto-sans-kannada/kannada-700.css';
import '@fontsource/noto-sans-oriya/oriya-400.css';
import '@fontsource/noto-sans-oriya/oriya-500.css';
import '@fontsource/noto-sans-oriya/oriya-700.css';
import './app.css';
import App from './App.svelte';
import { initSounds } from './lib/sound';
import { mount } from 'svelte';

initSounds();

const app = mount(App, {
  target: document.getElementById('app')!
});

// Register the PWA service worker in production only — it has no offline
// caching (see public/sw.js), so it adds nothing in dev besides an extra
// reload source, but registering it is what makes Chrome/Android offer the
// standalone "Add to Home Screen" install flow instead of a plain shortcut,
// and is required to receive Web Push notifications.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Installability/push is a progressive enhancement; a failed
      // registration shouldn't block the app from working as a normal tab.
    });
  });
}

export default app;
